(() => {
  'use strict';

  const body = document.body;
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  const setOpen = (element, open) => {
    if (!element) return;
    if (open) {
      element.hidden = false;
      requestAnimationFrame(() => element.classList.add('is-open'));
    } else {
      element.classList.remove('is-open');
      window.setTimeout(() => { if (!element.classList.contains('is-open')) element.hidden = true; }, 220);
    }
  };
  const lockBody = lock => body.classList.toggle('sp-scroll-lock', lock);
  const isOpen = element => !!element && !element.hidden && element.classList.contains('is-open');

  const mobileMenu = qs('[data-sp-mobile-menu]');
  const menuOpen = qs('[data-sp-menu-open]');
  let menuPreviousFocus = null;
  const closeMenu = (restoreFocus = true) => {
    if (!mobileMenu || mobileMenu.hidden) return;
    setOpen(mobileMenu, false);
    if (menuOpen) menuOpen.setAttribute('aria-expanded', 'false');
    lockBody(false);
    if (restoreFocus && menuPreviousFocus) menuPreviousFocus.focus();
  };
  if (menuOpen && mobileMenu) {
    menuOpen.addEventListener('click', () => {
      menuPreviousFocus = document.activeElement;
      setOpen(mobileMenu, true);
      menuOpen.setAttribute('aria-expanded', 'true');
      lockBody(true);
      const first = qs(focusableSelector, mobileMenu);
      if (first) window.setTimeout(() => first.focus(), 70);
    });
    qsa('[data-sp-menu-close]').forEach(button => button.addEventListener('click', () => closeMenu()));
  }

  const searchPanel = qs('[data-sp-search-panel]');
  const searchOpen = qs('[data-sp-search-open]');
  let searchPreviousFocus = null;
  const closeSearch = (restoreFocus = true) => {
    if (!searchPanel || searchPanel.hidden) return;
    setOpen(searchPanel, false);
    if (searchOpen) searchOpen.setAttribute('aria-expanded', 'false');
    if (restoreFocus && searchPreviousFocus) searchPreviousFocus.focus();
  };
  if (searchOpen && searchPanel) {
    searchOpen.addEventListener('click', () => {
      const opening = searchPanel.hidden || !searchPanel.classList.contains('is-open');
      if (opening) {
        searchPreviousFocus = document.activeElement;
        setOpen(searchPanel, true);
        searchOpen.setAttribute('aria-expanded', 'true');
        const input = qs('input[type="search"]', searchPanel);
        if (input) window.setTimeout(() => input.focus(), 70);
      } else closeSearch();
    });
    const close = qs('[data-sp-search-close]');
    if (close) close.addEventListener('click', () => closeSearch());
  }

  const predictiveInput = qs('[data-sp-predictive-input]');
  const predictiveResults = qs('[data-sp-predictive-results]');
  let predictiveTimer = null;
  let predictiveController = null;
  const hidePredictive = () => {
    if (!predictiveResults) return;
    predictiveResults.hidden = true;
    predictiveResults.innerHTML = '';
  };
  if (predictiveInput && predictiveResults) {
    predictiveInput.addEventListener('input', () => {
      window.clearTimeout(predictiveTimer);
      const term = predictiveInput.value.trim();
      if (term.length < 2) { hidePredictive(); return; }
      predictiveTimer = window.setTimeout(async () => {
        if (predictiveController) predictiveController.abort();
        predictiveController = new AbortController();
        const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
        const url = `${root}search?q=${encodeURIComponent(term)}&type=product&view=predictive`;
        predictiveResults.hidden = false;
        predictiveResults.innerHTML = '<p class="sp-predictive__loading">Szukamy…</p>';
        try {
          const response = await fetch(url, { signal: predictiveController.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error(`Search ${response.status}`);
          predictiveResults.innerHTML = await response.text();
        } catch (error) {
          if (error.name !== 'AbortError') hidePredictive();
        }
      }, 180);
    });
    predictiveInput.addEventListener('keydown', event => { if (event.key === 'Escape') hidePredictive(); });
  }

  const filterDrawer = qs('[data-sp-filter-drawer]');
  const filterOpeners = qsa('[data-sp-filter-open]');
  let filterPreviousFocus = null;
  const closeFilters = (restoreFocus = true) => {
    if (!filterDrawer || filterDrawer.hidden) return;
    setOpen(filterDrawer, false);
    filterOpeners.forEach(button => button.setAttribute('aria-expanded', 'false'));
    lockBody(false);
    if (restoreFocus && filterPreviousFocus) filterPreviousFocus.focus();
  };
  if (filterDrawer && filterOpeners.length) {
    filterOpeners.forEach(button => button.addEventListener('click', () => {
      filterPreviousFocus = document.activeElement;
      setOpen(filterDrawer, true);
      filterOpeners.forEach(opener => opener.setAttribute('aria-expanded', 'true'));
      lockBody(true);
      const first = qs(focusableSelector, filterDrawer);
      if (first) window.setTimeout(() => first.focus(), 70);
    }));
    qsa('[data-sp-filter-close]').forEach(button => button.addEventListener('click', () => closeFilters()));
  }

  qsa('[data-sp-sort]').forEach(select => {
    select.addEventListener('change', () => {
      const formId = select.getAttribute('form');
      const form = formId ? document.getElementById(formId) : select.closest('form');
      if (form) form.submit();
    });
  });

  const finder = qs('[data-sp-finder]');
  if (finder) {
    const type = qs('[data-sp-finder-type]', finder);
    const style = qs('[data-sp-finder-style]', finder);
    const submit = qs('[data-sp-finder-submit]', finder);
    if (submit && type) {
      submit.addEventListener('click', () => {
        if (!type.value) {
          type.focus();
          type.classList.add('has-error');
          return;
        }
        type.classList.remove('has-error');
        const target = new URL(`/collections/${type.value}`, window.location.origin);
        if (style && style.value) {
          const selected = style.options[style.selectedIndex];
          const filterKey = selected.dataset.filterKey;
          if (filterKey) target.searchParams.set(`filter.p.m.spinkarnia_filters.${filterKey}`, style.value);
        }
        window.location.href = target.pathname + target.search;
      });
      type.addEventListener('change', () => type.classList.remove('has-error'));
    }
  }

  qsa('.sp-card').forEach(card => {
    const secondary = qs('[data-sp-secondary-image]', card);
    if (!secondary) return;
    const hydrate = () => {
      if (secondary.dataset.loaded === 'true') return;
      if (secondary.dataset.src) secondary.src = secondary.dataset.src;
      if (secondary.dataset.srcset) secondary.srcset = secondary.dataset.srcset;
      secondary.dataset.loaded = 'true';
    };
    card.addEventListener('pointerenter', hydrate, { once: true });
    card.addEventListener('focusin', hydrate, { once: true });
  });

  document.addEventListener('keydown', event => {
    const overlay = isOpen(filterDrawer) ? filterDrawer : (isOpen(mobileMenu) ? mobileMenu : null);
    if (event.key === 'Tab' && overlay) {
      const focusables = qsa(focusableSelector, overlay).filter(el => el.offsetParent !== null);
      if (focusables.length) {
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }
    if (event.key !== 'Escape') return;
    if (isOpen(filterDrawer)) closeFilters();
    else if (isOpen(mobileMenu)) closeMenu();
    else if (isOpen(searchPanel)) closeSearch();
  });
})();
